/*
 * @Author: wangjiaxiang
 * @Date: 2022-08-18 09:45:47
 * @LastEditTime: 2022-08-26 19:43:42
 * @LastEditors: wangjiaxiang
 * @Description: 宝宝数据
 * @FilePath: /大增长星妈会C端/xmh-front-content/src/utils/mockData/babyBMI.js
 *
 */
export default {
  // 宝宝孕期身高和体重
  babyPregnancyBMI: {
    0: { height: "0mm", weight: "0g" },
    1: { height: "0mm", weight: "0g" },
    2: { height: "约0.1mm", weight: "0.1g" },
    3: { height: "大于1mm", weight: "0.2g" },
    4: { height: "2mm", weight: "0.3g" },
    5: { height: "4mm", weight: "0.4g" },
    6: { height: "8mm", weight: "0.5g" },
    7: { height: "1.6cm", weight: "1g" },
    8: { height: "2.3cm", weight: "2g" },
    9: { height: "3cm", weight: "4g" },
    10: { height: "4.1cm", weight: "7g" },
    11: { height: "5.4cm", weight: "14g" },
    12: { height: "7.4mm", weight: "23g" },
    13: { height: "8.7cm", weight: "43g" },
    14: { height: "10.1cm", weight: "70g" },
    15: { height: "11.6cm", weight: "100g" },
    16: { height: "13cm", weight: "140g" },
    17: { height: "14.2mm", weight: "190g" },
    18: { height: "15.3mm", weight: "240g" },
    19: { height: "16.4cm", weight: "300g" },
    20: { height: "26.7cm", weight: "360g" },
    21: { height: "27.8cm", weight: "430g" },
    22: { height: "28.9cm", weight: "501g" },
    23: { height: "30cm", weight: "600g" },
    24: { height: "34.6cm", weight: "660g" },
    25: { height: "35.6cm", weight: "760g" },
    26: { height: "26.6cm", weight: "875g" },
    27: { height: "37.6cm", weight: "1kg" },
    28: { height: "38.6cm", weight: "1.2kg" },
    29: { height: "39.9cm", weight: "1.3kg" },
    30: { height: "41.1cm", weight: "1.5g" },
    31: { height: "42.4cm", weight: "1.7kg" },
    32: { height: "43.7cm", weight: "1.9kg" },
    33: { height: "45cm", weight: "2.1kg" },
    34: { height: "46.2cm", weight: "2.4kg" },
    35: { height: "47.4cm", weight: "2.6kg" },
    36: { height: "48.6cm", weight: "2.9kg" },
    37: { height: "49.8cm", weight: "3.1kg" },
    38: { height: "50cm", weight: "3.2kg" },
    39: { height: "50.4cm", weight: "3.32kg" },
    40: { height: "50.4cm", weight: "3.32kg" },
  },
  boyBMI:{
    0: { height: "50.4cm", weight: "3.32kg" },
    1: { height: "54.8cm", weight: "4.51kg" },
    2: { height: "58.7cm", weight: "5.68kg" },
    3: { height: "62cm", weight: "6.7kg" },
    4: { height: "64.6cm", weight: "7.45kg" },
    5: { height: "66.7cm", weight: "8kg" },
    6: { height: "68.4cm", weight: "8.41kg" },
    7: { height: "69.8cm", weight: "8.76kg" },
    8: { height: "71.2cm", weight: "9.05kg" },
    9: { height: "72.6cm", weight: "9.33kg" },
    10: { height: "74cm", weight: "9.58kg" },
    11: { height: "75.3cm", weight: "9.83kg" },
    12: { height: "76.5cm", weight: "10.05kg" },
    13: { height: "76.5cm", weight: "10.05kg" },
    14: { height: "76.5cm", weight: "10.05kg" },
    15: { height: "79.8cm", weight: "10.68kg" },
    16: { height: "79.8cm", weight: "10.68kg" },
    17: { height: "79.8cm", weight: "10.68kg" },
    18: { height: "82.7cm", weight: "11.29kg" },
    19: { height: "82.7cm", weight: "11.29kg" },
    20: { height: "82.7cm", weight: "11.29kg" },
    21: { height: "85.6cm", weight: "11.93kg" },
    22: { height: "85.6cm", weight: "11.93kg" },
    23: { height: "85.6cm", weight: "11.93kg" },
    24: { height: "88.5cm", weight: "12.54kg" },
    25: { height: "88.5cm", weight: "12.54kg" },
    26: { height: "88.5cm", weight: "12.54kg" },
    27: { height: "91.1cm", weight: "13.11kg" },
    28: { height: "91.1cm", weight: "13.11kg" },
    29: { height: "91.1cm", weight: "13.11kg" },
    30: { height: "93.3cm", weight: "13.64kg" },
    31: { height: "93.3cm", weight: "13.64kg" },
    32: { height: "93.3cm", weight: "13.64kg" },
    33: { height: "95.4cm", weight: "14.15kg" },
    34: { height: "95.4cm", weight: "14.15kg" },
    35: { height: "95.4cm", weight: "14.15kg" },
    36: { height: "96.8cm", weight: "14.65kg" },
    37: { height: "96.8cm", weight: "14.65kg" },
    38: { height: "96.8cm", weight: "14.65kg" },
    39: { height: "98.8cm", weight: "15.15kg" },
    40: { height: "98.8cm", weight: "15.15kg" },
    41: { height: "98.8cm", weight: "15.15kg" },
    42: { height: "100.6cm", weight: "15.63kg" },
    43: { height: "100.6cm", weight: "15.63kg" },
    44: { height: "100.6cm", weight: "15.63kg" },
    45: { height: "102.4cm", weight: "16.13kg" },
    46: { height: "102.4cm", weight: "16.13kg" },
    47: { height: "102.4cm", weight: "16.13kg" },
    48: { height: "104.1cm", weight: "16.64kg" },
    49: { height: "104.1cm", weight: "16.64kg" },
    50: { height: "104.1cm", weight: "16.64kg" },
    51: { height: "105.9cm", weight: "17.18kg" },
    52: { height: "105.9cm", weight: "17.18kg" },
    53: { height: "105.9cm", weight: "17.18kg" },
    54: { height: "107.7cm", weight: "17.75kg" },
    55: { height: "107.7cm", weight: "17.75kg" },
    56: { height: "107.7cm", weight: "17.75kg" },
    57: { height: "109.5cm", weight: "18.35kg" },
    58: { height: "109.5cm", weight: "18.35kg" },
    59: { height: "109.5cm", weight: "18.35kg" },
    60: { height: "111.3cm", weight: "18.98kg" },
    61: { height: "111.3cm", weight: "18.98kg" },
    62: { height: "111.3cm", weight: "18.98kg" },
    63: { height: "113cm", weight: "19.6kg" },
    64: { height: "113cm", weight: "19.6kg" },
    65: { height: "113cm", weight: "19.6kg" },
    66: { height: "114.7cm", weight: "20.18kg" },
    67: { height: "114.7cm", weight: "20.18kg" },
    68: { height: "114.7cm", weight: "20.18kg" },
    69: { height: "116.3cm", weight: "20.75kg" },
    70: { height: "116.3cm", weight: "20.75kg" },
    71: { height: "116.3cm", weight: "20.75kg" },
    72: { height: "117.7cm", weight: "21.26kg" },
  },
  girlBMI:{
    0: { height: "49.7cm", weight: "3.21kg" },
    1: { height: "53.7cm", weight: "4.2kg" },
    2: { height: "57.4cm", weight: "5.21kg" },
    3: { height: "60.6cm", weight: "6.13kg" },
    4: { height: "63.1cm", weight: "6.83kg" },
    5: { height: "65.2cm", weight: "7.63kg" },
    6: { height: "66.8cm", weight: "7.77kg" },
    7: { height: "68.2cm", weight: "8.11kg" },
    8: { height: "69.6cm", weight: "8.41kg" },
    9: { height: "71cm", weight: "8.69kg" },
    10: { height: "72.4cm", weight: "8.94kg" },
    11: { height: "73.7cm", weight: "9.18kg" },
    12: { height: "75cm", weight: "9.4kg" },
    13: { height: "75cm", weight: "9.4kg" },
    14: { height: "75cm", weight: "9.4kg" },
    15: { height: "78.5cm", weight: "10.02kg" },
    16: { height: "78.5cm", weight: "10.02kg" },
    17: { height: "78.5cm", weight: "10.02kg" },
    18: { height: "81.5cm", weight: "10.65kg" },
    19: { height: "81.5cm", weight: "10.65kg" },
    20: { height: "81.5cm", weight: "10.65kg" },
    21: { height: "84.4cm", weight: "11.3kg" },
    22: { height: "84.4cm", weight: "11.3kg" },
    23: { height: "84.4cm", weight: "11.3kg" },
    24: { height: "87.2cm", weight: "11.92kg" },
    25: { height: "87.2cm", weight: "11.92kg" },
    26: { height: "87.2cm", weight: "11.92kg" },
    27: { height: "89.8cm", weight: "12.5kg" },
    28: { height: "89.8cm", weight: "12.5kg" },
    29: { height: "89.8cm", weight: "12.5kg" },
    30: { height: "92.1cm", weight: "13.05kg" },
    31: { height: "92.1cm", weight: "13.05kg" },
    32: { height: "92.1cm", weight: "13.05kg" },
    33: { height: "94.3cm", weight: "13.59kg" },
    34: { height: "94.3cm", weight: "13.59kg" },
    35: { height: "94.3cm", weight: "13.59kg" },
    36: { height: "95.6cm", weight: "14.13kg" },
    37: { height: "95.6cm", weight: "14.13kg" },
    38: { height: "95.6cm", weight: "14.13kg" },
    39: { height: "97.5cm", weight: "14.65kg" },
    40: { height: "97.5cm", weight: "14.65kg" },
    41: { height: "97.5cm", weight: "14.65kg" },
    42: { height: "99.4cm", weight: "15.16kg" },
    43: { height: "99.4cm", weight: "15.16kg" },
    44: { height: "99.4cm", weight: "15.16kg" },
    45: { height: "101.2cm", weight: "15.67kg" },
    46: { height: "101.2cm", weight: "15.67kg" },
    47: { height: "101.2cm", weight: "15.67kg" },
    48: { height: "103.1cm", weight: "16.17kg" },
    49: { height: "103.1cm", weight: "16.17kg" },
    50: { height: "103.1cm", weight: "16.17kg" },
    51: { height: "104.9cm", weight: "16.69kg" },
    52: { height: "104.9cm", weight: "16.69kg" },
    53: { height: "104.9cm", weight: "16.69kg" },
    54: { height: "106.7cm", weight: "17.22kg" },
    55: { height: "106.7cm", weight: "17.22kg" },
    56: { height: "106.7cm", weight: "17.22kg" },
    57: { height: "108.5cm", weight: "17.75kg" },
    58: { height: "108.5cm", weight: "17.55kg" },
    59: { height: "108.5cm", weight: "17.55kg" },
    60: { height: "110.2cm", weight: "18.26kg" },
    61: { height: "110.2cm", weight: "18.26kg" },
    62: { height: "110.2cm", weight: "18.26kg" },
    63: { height: "111.9cm", weight: "18.78kg" },
    64: { height: "111.9cm", weight: "18.78kg" },
    65: { height: "111.9cm", weight: "18.78kg" },
    66: { height: "113.5cm", weight: "19.33kg" },
    67: { height: "113.5cm", weight: "19.33kg" },
    68: { height: "113.5cm", weight: "19.33kg" },
    69: { height: "115.2cm", weight: "19.88kg" },
    70: { height: "115.2cm", weight: "19.88kg" },
    71: { height: "115.2cm", weight: "19.88kg" },
    72: { height: "116.6cm", weight: "20.37kg" },
  }
};
